export const buildNumber = '20260828.1';
export const version = 'main';
export const latestCommit = '33c6ac4b17a625c57f05bfda579f0cd4149f324e';
